import SurveyModel from '@/shared/models/business/SurveyModel'
import { loading } from '@/shared/utils/UIHelper'
import SurveyRepository from '@/shared/http/repositories/business/Survey'
import searchSurvey from '@/views/private/Survey/components/searchSurvey/searchSurvey.vue'
import tableSurvey from '@/views/private/Survey/components/tableSurvey/tableSurvey.vue'
import formSurey from '@/views/private/Survey/components/formSurvey/formsurvey.vue'
import surveyForm from '@/views/private/Survey/surveyboard-form.js'
import PermisionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  mixins: [PermisionMixin],
  components: {
    searchSurvey,
    tableSurvey,
    formSurey
  },
  name: 'Surveyboard',
  data () {
    return {
      data: SurveyModel,
      datafilter: SurveyModel,
      title: 'Detalhes Vistoria',
      form: surveyForm,
      mudar: true,
      roles: Roles,
      filtroFinal: SurveyModel
    }
  },
  methods: {
    getByid (Id) {
      loading.push()
      SurveyRepository.Get(Id)
        .then(Response => {
          this.data = Response.data.data
          loading.pop()
        })
        .catch(error => this.onException(error))
    },
    onUpdate () {
      loading.push()
      this.data.status = parseInt(this.data.status)
      SurveyRepository.Update(this.data)
        .then(Response => this.onResult(Response))
        .catch(erro => this.onException(erro))
    },
    filter (pagingLimit = 10, pagingIndex = 1) {
      loading.push()
      this.datafilter.tecnicoResponsavelId = this.form.responsavelID.value
      this.datafilter.dataVistoria = this.form.dataInicioSolicitacao.value
      this.datafilter.statusvistoria = this.form.statusVistoria.value
      this.datafilter.tipoObraId = this.form.TipoObraID.value
      if (this.verificarFiltro()) {
        let obj = this.datafilter
        this.filtroFinal = obj
        SurveyRepository.GetAllTableSST(pagingLimit, pagingIndex, this.datafilter)
          .then(Response => {
            this.$refs.SurveyTable.loadTable(Response)
            this.$refs.SurveyTable.ChangeData(Response.data.data)
            loading.pop()
          })
          .catch(error => this.onException(error))
      } else {
        this.$refs.SurveyTable.onLoad()
        loading.pop()
      }
    },
    verificarFiltro () {
      let obj = this.datafilter
      if (obj.codigoObra == null && obj.nome == null && obj.statusvistoria == null && obj.dataVistoria == null && obj.tecnicoResponsavelId == null && obj.funcao == null && obj.tipoObraId == null &&
         obj.numeroContrato == null) return false
      return true
    },
    onResetBoard () {
      this.$refs.Board.showHistory = false
      this.$refs.Board.dataHistory = null
      this.$refs.Board.hasNewEmployee = false
      this.$refs.Board.hasNewBoard = false
    },
    onEdit (obj) {
      this.data = obj
      this.data.responsavel = obj.responsavelNome
      this.mudar = false
    },
    RefreshPag () {
      window.location.reload()
    },
    ClearSearch () {
      this.datafilter.codigoObra = null
      this.datafilter.numeroContrato = null
      this.datafilter.cliente = null
      this.datafilter.funcao = null
      this.$refs.searchSuvey.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/surveyBoard.js